export default __webpack_public_path__ + "static/media/misc-drawerA.316d2a17.jpg";